<template>
  <page>
    <template slot="content">
      <help-content :title="'参加中のイベントを退出したい'">
        <template slot="content">
          <div class="text">
            イベントは主催者ごとのグループに開催されています。イベントの退出はグループ管理者にお問い合わせください。<br><br>
            スライドメニューのMYグループからグループを退会すれば、そのグループが開催しているすべてのイベントから退出することができます。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help37.vue